export default (value) => (dispatch) => {
  dispatch({
    type: 'GROUNDS/CHANGE_ERROR',
    payload: value,
  });
};
